export default "__VITE_ASSET__Y4DcS$nT__"